export default __webpack_public_path__ + "static/media/Simrishamn_full.aac503e7.png";